import { DependenciesInjection } from "app/di/DependencyInjection";
import { FilterRepositoryImpl } from "../data/FilterRepositoryImpl";
import { IFilterRepository } from "../domain/repository/IFilterRepository";
import { FilterUseCase } from "../domain/useCase/FilterUseCase";
import { FilterToken } from "./FilterToken";

export class FilterInjection {
  static initInjections() {
    DependenciesInjection.register<IFilterRepository>(
      FilterToken.IFilterRepository,
      FilterRepositoryImpl,
      "otherRepo",
    );
    DependenciesInjection.register<FilterUseCase>(
      FilterToken.FilterUseCase,
      FilterUseCase,
      "otherRepo",
    );
  }

  static getRepo() {
    return DependenciesInjection.getRepo<IFilterRepository>(
      FilterToken.IFilterRepository,
    );
  }

  static getUseCase() {
    return DependenciesInjection.getRepo<FilterUseCase>(
      FilterToken.FilterUseCase,
    );
  }
}
